export default "__VITE_ASSET__C9MmbAcp__"